import React from "react";
import { arrayOf, bool, func, oneOf, string } from "prop-types";

import { cmsPlacementsPropType } from "../../constants/cmsPropTypes";
import ContentManagementSystem from "../ContentManagementSystem";

const App = ({
  cmsPlacements,
  handleSetTarget,
  isHiddenSeparator,
  location,
  userSegments,
  ...passThroughProps
}) => (
  <>
    {cmsPlacements?.length > 0 && (
      <ContentManagementSystem
        cmsPlacements={cmsPlacements}
        handleSetTarget={handleSetTarget}
        isHiddenSeparator={isHiddenSeparator}
        location={location}
        userSegments={userSegments}
        {...passThroughProps}
      />
    )}
  </>
);

App.propTypes = {
  cmsPlacements: cmsPlacementsPropType,
  location: oneOf(["body", "header", "propertiesTab"]).isRequired,
  handleSetTarget: func,
  isHiddenSeparator: bool,
  userSegments: arrayOf(string).isRequired
};

App.defaultProps = {
  cmsPlacements: [],
  handleSetTarget: () => {},
  isHiddenSeparator: false
};

export default App;
